import type { CountryForSelect } from 'models';

export const sortCountriesByLabel = (countries: CountryForSelect[]) =>
  countries.sort((a, b) => a.label.localeCompare(b.label));
